<template>
  <transition name="grow">
    <base-modal @close="$emit('close')" head="transfer_keys">
      <FormError :errors="errors" class="text-sm" />
      <div class="flex flex-col sm:flex-row sm:space-x-8 items-center justify-between">
        <div class="w-full sm:w-64 max-w-sm">
          <span class="mb-1 flex font-semibold">{{ $t(`mygwf.components.Label.serial`) }}</span>
          <div class="h-72 overflow-y-scroll space-y-1 border p-4 mb-3">
            <div v-for="(row, i) in items" :key="i" class="w-full tracking-wide text-sm">
              {{ row.data.serial || row.data.device_eui || row.data.serial_number }}
            </div>
          </div>
        </div>
        <base-icon
          :class="[
            'text-5xl transform sm:-rotate-90',
            company !== '' ? 'text-primary' : 'text-secondary-dark',
          ]"
          icon="arrow-down"
        />
        <div class="items-center sm:w-128">
          <dt class="mb-2 leading-5 font-semibold">
            {{ $t(`mygwf.components.Form.company`) }}
          </dt>
          <dd class="leading-5">
            <SingleSelect
              :options="companies"
              class="w-full shadow p-4 text-sm"
              v-model="company"
            />
          </dd>
        </div>
      </div>
      <div class="pt-4 mt-6 border-t flex flex-col justify-end w-full">
        <base-alert
          v-if="securityCheck !== securityCode"
          text="security_confirm"
          type="info"
          size="sm"
        />
        <base-alert v-else text="security_pass" type="success" size="sm" />

        <div class="flex flex-col">
          <div class="flex space-x-4">
            <base-button
              class="w-1/2"
              @click="$emit('close')"
              :disabled="loading"
              action="close"
              context="secondary"
            >
              <base-icon icon="close" />
            </base-button>
            <div class="w-1/2">
              <base-input v-if="securityCheck !== securityCode" v-model="securityCheck" condensed />
              <base-button
                v-else
                @click="submit"
                action="transfer"
                :loading="loading"
                class="w-full"
              >
                <base-icon icon="transfer" />
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </base-modal>
  </transition>
</template>

<script>
import {BaseAlert, BaseModal, BaseButton, BaseIcon, BaseInput, BaseSelect} from '@/components/base'
import SingleSelect from '@/components/shared/SingleSelect.vue'

export default {
  data() {
    return {
      company: '',
      loading: false,
      pk: this.$store.getters['keys/pk'],
      errors: {},
      securityCheck: '',
      securityCode: 'TRANSFER',
    }
  },
  computed: {
    companies() {
      return this.$store.getters['companies/list']
    },
  },
  methods: {
    submit() {
      const devices = this.items.reduce((acc, key) => [...acc, key[this.pk]], [])
      let request = {company_to: this.company, devices}
      this.loading = true
      this.$store
        .dispatch(`keys/transfer`, request)
        .then(data => {
          this.$store.dispatch('app/notification', {
            type: 'success',
            group: 'app',
            text: `transfer`,
          })
          this.$emit('success')
          this.$emit('close')
        })
        .catch(errors => {
          this.errors = errors
        })
        .finally(() => (this.loading = false))
    },
  },
  props: {
    items: {
      type: Array,
    },
  },
  components: {
    BaseAlert,
    BaseButton,
    BaseIcon,
    BaseInput,
    BaseModal,
    BaseSelect,
    SingleSelect,
    FormError: () => import('@/components/shared/FormError.vue'),
  },
}
</script>
